import { useRef } from 'react';

/** Keeps a ref aligned with the latest value each render (no effect needed). */
export function useLatestRef(value) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
